<template>
    <v-alert dense text color="primary" type="info" class="alert-class">
        <span v-if="text"> {{text}}</span>
        <TranslatableStringComponent v-else :tstring="{string: 'temporaryUnavailableOnlineCheckoutNote'}" />
    </v-alert>
</template>
<script>
import TranslatableStringComponent from '~/components/TranslatableStringComponent.vue' 
export default {
    name: 'CheckoutDisabledAlert',
    components: {
        TranslatableStringComponent,
    },
    props: {
        text: {
            type: String,
            default: null,
        },
    },
}
</script>
<style scoped>
.alert-class {
    width: -webkit-fill-available !important;
}
</style>
